
export enum MetricThresholdContextCd {
	GOAL = 'Goal',
	VARIANCE = 'Variance'}

